<template>
  <div class="manage-invite">
    <flash-message v-if="errorMessage != null" error>{{
      errorMessage
    }}</flash-message>
    <app-button
      :loading="loading == 'accept'"
      v-if="loading != 'decline'"
      success
      class="accept"
      thinner
      @click="accept"
      >Uitnodiging accepteren</app-button
    >
    <app-button
      @click="decline"
      :loading="loading == 'decline'"
      v-if="loading != 'accept'"
      danger
      class="decline"
      thinner
      >Uitnodiging weigeren</app-button
    >
  </div>
</template>

<script lang="ts">
import { showToast } from "@/components/notifications/toast";
import { inProperties, PropertiesActions } from "@/store/properties";
import { computed, defineComponent, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const inviteToken = computed(() => route.params.token);

    const loading = ref(null as null | "accept" | "decline");

    const errorMessage = ref(null as null | string);

    return {
      loading,
      errorMessage,
      async accept() {
        loading.value = "accept";

        try {
          await store.dispatch(
            inProperties(PropertiesActions.ACCEPT_INVITE_TOKEN),
            { token: inviteToken.value }
          );
          showToast({
            type: "success",
            text: "Uitnodiging geaccepteerd",
          });
          setTimeout(() => {
            router.push({ name: "login" });
            loading.value = null;
          }, 2000);
        } catch (e) {
          if (e.response && e.response.status === 404) {
            errorMessage.value = "Link is ongeldig of al gebruikt.";
            return;
          }

          throw e;
        }
      },
      async decline() {
        loading.value = "decline";
        try {
          await store.dispatch(
            inProperties(PropertiesActions.DECLINE_INVITE_TOKEN),
            { token: inviteToken.value }
          );
          showToast({
            type: "success",
            text: "Uitnodiging geweigerd",
          });
          setTimeout(() => {
            router.push({ name: "login" });
            loading.value = null;
          }, 2000);
        } catch (e) {
          if (e.response && e.response.status === 404) {
            errorMessage.value = "Link is ongeldig of al gebruikt.";
            return;
          }

          throw e;
        }
      },
    };
  },
});
</script>

<style lang="scss" scoped>
.manage-invite {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 300px;
  display: flex;
  flex-flow: column nowrap;
}

.accept {
  margin-bottom: 10px;
}
</style>
